<template>
  <div v-if="currentUser.userId === form.author.id">
    <a-form-item label="Ý kiến">
      <a-textarea
        placeholder="Vui lòng nhập ý kiến"
        :rows="2"
        v-model="approvalNote"
      />
    </a-form-item>
    <a-button type="primary" @click="trinhDuyet" :loading="submiting">
      Trình duyệt
    </a-button>
  </div>
</template>
<script>
import gql from "graphql-tag";
import { mapMutations } from "vuex";
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      submiting: false,
      approvalNote: ""
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth;
    }
  },
  methods: {
    ...mapMutations({
      updateApproval: "form/updateApproval",
      setForm: "form/setForm"
    }),
    trinhDuyet() {
      this.submiting = true;

      const tranformData = {
        createdForm: this.form.id,
        approvalNote: this.approvalNote,
        approvalStatus: "Pending" // Luôn là Pending lúc mới trình duyệt
      };

      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation(
              $createdForm: ID!
              $approvalStatus: String!
              $approvalNote: String
            ) {
              createApprovalStep(
                data: {
                  createdFormId: $createdForm
                  approvalStatus: $approvalStatus
                  approvalNote: $approvalNote
                }
              ) {
                id
                createdForm {
                  id
                  title
                  code
                  description
                  approvalStatus
                  approvalCurrentStep
                  approvalTotalStep
                  createdFormFields {
                    id
                    name
                    code
                    description
                    type
                    value
                    createdAt
                    updatedAt
                  }
                  approvalSteps {
                    id
                    approvalCurrentStep
                    approvalStatus
                    approvalNote
                    createdAt
                    author {
                      username
                      fullname
                      department {
                        name
                      }
                      position {
                        name
                      }
                    }
                  }
                  currentApprovalStep {
                    stepOrder
                    stepName
                    user
                    department
                    position
                  }
                  author {
                    id
                    username
                  }
                  createdAt
                  updatedAt
                }
              }
            }
          `,
          // Parameters
          variables: tranformData
        })
        .then(data => {
          // Result
          console.log("Up thanh cong", data);
          if (
            data.data.createApprovalStep &&
            data.data.createApprovalStep.createdForm
          ) {
            this.setForm(data.data.createApprovalStep.createdForm);
          }
          this.submiting = false;
        })
        .catch(error => {
          // Error
          console.error("Up loi roi", error);
          this.submiting = false;
        });
    }
  }
};
</script>
